import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { workspaceApi } from '../api/workspace';
import { EmptyState, Loading, PageError } from '../components/State';
import { ageFromDob, fmtDate, initials } from '../lib/format';
import './FamiliesPage.css';

export function FamiliesPage() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['clients'],
    queryFn: workspaceApi.clients,
  });

  if (isLoading) return <Loading />;

  return (
    <div>
      <h1>Youth &amp; Families</h1>
      {isError || !data ? (
        <PageError error={error} onRetry={() => refetch()} />
      ) : data.length === 0 ? (
        <EmptyState text="No connected families yet. Connect using a caregiver's access code in the mobile app." />
      ) : (
        <div className="fam__grid">
          {data.map((c) => {
            const name = c.youthSnapshot?.name ?? 'Youth';
            const age = ageFromDob(c.youthSnapshot?.dob);
            return (
              <Link key={c.connectionId} to={`/families/${c.connectionId}`} className="card fam__card">
                <div className="fam__avatar">{initials(name)}</div>
                <div className="fam__meta">
                  <div className="fam__name">{name}</div>
                  <div className="muted fam__sub">
                    {age != null ? `Age ${age}` : 'Age —'} · connected {fmtDate(c.connectedAt?.split('T')[0])}
                  </div>
                </div>
                <span className="fam__chev">›</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
